import type { Language } from '@packages/config';
import { pathnameHasSupportedLanguage } from '../pathnameHasSupportedLanguage/pathnameHasSupportedLanguage';

/** Returns the **supported** language from the given url or `undefined` if the url does not contain any of the shop-supported languages */
export const getLanguageFromUrl = (url: string) =>
  pathnameHasSupportedLanguage(url) ? (url.substring(1, 3) as Language) : undefined;
